import { formatMoney } from '@shopify/theme-currency';


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.initPromotions();

    this.debouncedOnChange = debounce((event) => {

      // elements not to be gift wrapped
      let elements_not_to_be_giftwrapped = document.querySelectorAll('[data-cart-gift]');
      let should_be_gift_wrapped = true;

      // check if event.target should be skipped
      elements_not_to_be_giftwrapped.forEach(function(element) {
        if (element == event.target) {
          should_be_gift_wrapped = false;
          return;
        }
      });

      if (should_be_gift_wrapped) {
        this.giftWrapInit(event);
      }

    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  /////
  //  index giftwrap
  ////

  combineGiftMessage(event) {

    event.preventDefault();

    // show spinner
    this.showBuyButtonSpinner();

    // if there is a gift_wrap - apply line item properties
    if (document.querySelector('[data-product-giftwrap]')) {

      let line = document.querySelector('[data-product-giftwrap]').dataset.productGiftwrap;
      let properties = {};
      console.log('combine gift message');
      let itemQuantity = document.querySelector('[data-product-giftwrap] .quantity__input').value;

      if (document.getElementById('Gift-message') !== null) {
        if (document.getElementById('Gift-message').checked) {
          let messageArray = document.querySelectorAll('[data-cart-gift]');
          messageArray.forEach(function(message) {
            if (message.value.length > 0 && message.name.length) {
              properties[message.name] = message.value
            }
          });
        } else {
          properties['__gift_message'] = false;
        }
      }

      const body = JSON.stringify({
        quantity: itemQuantity,
        line: line,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
        properties
      });

      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        let gift_wish = properties['__Gift_Wish'];
        localStorage.setItem('gift_message', gift_wish);

        // proceed to checkout
        window.location.href = window.location.origin + '/checkout';

      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
    } else {
      let attributes = {};
      if (document.getElementById('Gift-message') !== null) {
        if (document.getElementById('Gift-message').checked) {
          let messageArray = document.querySelectorAll('[data-cart-gift]');
          messageArray.forEach(function(message) {
            if (message.value.length > 0 && message.name.length) {
              attributes[message.name] = message.value
            }
          });
        } else {
          attributes['__gift_message'] = false;
        }
      }

      const body = JSON.stringify({
        attributes: attributes
      });

      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        const parsedState = JSON.parse(state);
        // proceed to checkout or cart
        let cart_url = window.location.origin + '/cart';
        if (window.location.href === cart_url) {
          window.location.href = window.location.origin + '/checkout';
        } else {
          window.location.href = window.location.origin + '/cart';
        }

      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
    }

  }

  updateLineItemProperties(product, giftWrapRemoved, giftWrapQuantity, ) {

    console.log('updates line item props');

    let body = '';

    // build properties
    let properties = {};
    properties['_gift_wrap'] = true;

    let cart_url = `${routes.cart_change_url}`;
    let product_quantity = product.querySelector('.quantity__input').value;

    let line = product.dataset.productLine;
    let new_line = parseFloat(line);

    if (giftWrapRemoved) {
      new_line = parseFloat(line) - 1;
      properties['_gift_wrap'] = false;
    }

    else {
      if (giftWrapQuantity == 0) {
        new_line = parseFloat(line) + 1;
      } else {
        if (product.querySelector('[data-cart-gift-wrap]').checked === false) {
          new_line = parseFloat(line);
          properties['_gift_wrap'] = false;
        }
      }
    }

    if (product.querySelector('[data-promo-item]') !== null) {
      properties['_promotion'] = true;
    }

    body = JSON.stringify({
      line: new_line,
      quantity: parseFloat(product_quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      properties
    });

    fetch(cart_url, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          this.initPromotions();
        }));
        this.disableLoading();
      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  addGiftWrap(product, giftWrapID) {

    let cart_url = `${routes.cart_add_url}`;
    let quantity = document.querySelector('[data-cart-gift-wrap]:checked').closest('[data-product-id]').querySelector('.quantity__input').value;
    let body = JSON.stringify({
      items: [
        {
          quantity: parseFloat(quantity),
          id: giftWrapID,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        }
      ]
    });

    fetch(cart_url, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      // updates line item properties
      this.updateLineItemProperties(product, false, 0);
    })
    .catch((error) => {
      document.querySelector('.loading-overlay').classList.add('hidden');
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
      this.disableLoading();
    });

  }

  increaseGiftWrap(product, giftWrapID) {

    let cart_url = `${routes.cart_change_url}`;

    let quantitySelectors = document.querySelectorAll('[data-cart-gift-product]:checked');
    let quantity = 0;
    quantitySelectors.forEach(function(quantitySelector) {
      let extra_quantity = quantitySelector.closest('[data-product-id]').querySelector('quantity-input input').value;
      quantity = quantity + parseFloat(extra_quantity);
    });
    let new_quantity = parseFloat(quantity);

    let body = JSON.stringify({
      quantity: new_quantity,
      id: giftWrapID,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(cart_url, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateLineItemProperties(product, false, new_quantity);
      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  removeGiftWrap(giftWrapID) {
    let body = JSON.stringify({
      quantity: 0,
      id: giftWrapID,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {

      const parsedState = JSON.parse(state);
      this.getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      this.disableLoading();

    })
    .catch((error) => {
      document.querySelector('.loading-overlay').classList.add('hidden');
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
      this.disableLoading();
    });
  }

  decreaseGiftWrap(product, giftWrapID) {

    let quantitySelectors = document.querySelectorAll('[data-cart-gift-product]:checked');
    let quantity = 0;
    quantitySelectors.forEach(function(quantitySelector) {
      let extra_quantity = quantitySelector.closest('[data-product-id]').querySelector('quantity-input input').value;
      quantity = quantity + parseFloat(extra_quantity);
    });
    let new_quantity = parseFloat(quantity);
    if (new_quantity < 0) {
      new_quantity = 0;
    }

    let body = JSON.stringify({
      quantity: new_quantity,
      id: giftWrapID,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        let giftWrapRemoved = false;
        if (new_quantity == 0) {
          giftWrapRemoved = true;
        }

        if (product != false) {
          this.updateLineItemProperties(product, giftWrapRemoved, new_quantity);
        } else {
          const parsedState = JSON.parse(state);
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
          this.disableLoading();
          this.checkPromotions();
        }

      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  calculateGiftWrap(giftWrapID, target) {

    // get values
    let product = target.closest('[data-product-id]');

    let giftWrap = document.querySelector('[data-product-giftwrap]');

    if (target == '') {
      this.decreaseGiftWrap(product, giftWrapID);
      return;
    }

    if (target.closest('.label') == null) {
      if (document.querySelector('[data-product-promotions] [data-cart-gift-wrap]:checked')) {
        return;
      }
    }

    // show loader
    target.closest('.label').querySelector('[data-loader]').classList.remove('hidden');

    // add or increase gift wrap
    if (target.checked) {
      if (giftWrap === null) {
        this.addGiftWrap(product, giftWrapID);
      } else {
        this.increaseGiftWrap(product, giftWrapID);
      }
    }

    // decrease or remove gift wrap
    else {
      this.decreaseGiftWrap(product, giftWrapID);
    }

  }

  // show checkout button spinner
  showBuyButtonSpinner() {
    let spinner = document.querySelector('[data-gift-wrap-spinner]');
    spinner.closest('button').querySelector('span').classList.add('hidden');
    spinner.classList.remove('hidden');
  }

  checkGiftWrap() {
    // check if gift message was previously added to cart
    if (document.getElementById('Gift-message') !== null) {

      let checkout_button = null;
      let cart_button = null;
      let cart_url = window.location.origin + '/cart';

      if (cart_url === window.location.href) {
        checkout_button = document.getElementById('cart').querySelector('button[type="submit"]');
      } else {
        checkout_button = document.getElementById('cart-drawer-form').querySelector('button[type="submit"]');
        cart_button = document.getElementById('cart-drawer-form').querySelector('.cart-drawer__footer ').querySelector('a');
      }

      if (document.getElementById('Gift-message').checked) {
        checkout_button.addEventListener('click', this.combineGiftMessage.bind(this));
        if (cart_button !== null) {
          cart_button.addEventListener('click', this.combineGiftMessage.bind(this));
        }
      } else {
        checkout_button.removeEventListener('click', this.combineGiftMessage.bind(this));
        if (cart_button !== null) {
          cart_button.removeEventListener('click', this.combineGiftMessage.bind(this));
        }
      }
    }
  }

  giftWrapInit(event) {

    // handle gift wrap product add/removal
    let itemArr = document.querySelectorAll('[data-cart-gift-wrap]');
    let itemFound = false;
    itemArr.forEach(function(item) {
      if (event.target == item) {
        itemFound = true;
      }
    });

    if (itemFound) {
      let giftWrapId = document.querySelector('[data-cart-gift-product]').dataset.cartGiftProduct;
      this.calculateGiftWrap(giftWrapId, event.target);
    }
    else {

      // handle gift message
      if (event.target == document.getElementById('Gift-message')) {

        document.querySelector('[data-cart-gift-message]').classList.toggle('cart__giftwrap-message--is-open');

        let checkout_button = null;
        let cart_button = null;
        let cart_url = window.location.origin + '/cart';

        if (cart_url === window.location.href) {
          checkout_button = document.getElementById('cart').querySelector('button[type="submit"]');
        } else {
          checkout_button = document.getElementById('cart-drawer-form').querySelector('button[type="submit"]');
          cart_button = document.getElementById('cart-drawer-form').querySelector('.cart-drawer__footer ').querySelector('a');
        }

        checkout_button.addEventListener('click', this.combineGiftMessage.bind(this));
        if (cart_button !== null) {
          cart_button.addEventListener('click', this.combineGiftMessage.bind(this));
        }
      }
      // default fallback
      else {
        if (document.querySelector('[data-cart-gift-product]') !== null) {
          let giftWrapId = document.querySelector('[data-cart-gift-product]').dataset.cartGiftProduct;
        }
        if (event.target.id == 'Gift-wrap') {
          this.calculateGiftWrap(giftWrapId, event.target);
        } else {
          this.onChange(event);
        }
      }
    }
  }


  /////
  //  index promotions
  ////

  initPromotions() {

    this.promo_executed = this.promo_executed || false;
    this.cart_amount = false;
    this.free_product = false;
    this.initiator_product = false;
    this.initiator_product_in_cart = false;
    this.promo_should_be_executed = false;
    this.free_product_in_cart = false;
    this.promo_is_valid = false;
    this.promo_type = false;

    this.checkPromotions();

  }

  checkPromotions() {

    this.promo_declined = sessionStorage.getItem('promo_declined') || false;

    let promos = document.querySelector('cart-promotions [data-options]');

    if (promos && promos.dataset && promos.dataset.options) {
      const jsonOptions = JSON.parse(promos.dataset.options);
      this.promo_executed = jsonOptions.promo_executed;
      this.cart_amount = jsonOptions.cart_amount;
      this.free_product = jsonOptions.free_product;
      this.initiator_product = jsonOptions.initiator_product;
      this.initiator_product_in_cart = jsonOptions.initiator_product;
      this.promo_should_be_executed = jsonOptions.promo_should_be_executed;
      this.free_product_in_cart = jsonOptions.free_product_in_cart;
      this.promo_is_valid = jsonOptions.promo_is_valid;
      this.promo_type = jsonOptions.promo_type;
    }

    let updateType = false;

    // promo type == X above Y
    if (this.promo_type == 'x_above_y') {
      // if promo is executed
      if (this.promo_executed) {
        if (!this.promo_should_be_executed || !this.promo_is_valid) {
          updateType = 'change';
        }
      }
      // if promo is not executed
      else {
        if (this.promo_should_be_executed) {
          updateType = 'add';
          if (this.free_product_in_cart) {
            updateType = 'edit';
          }
        }
        if (!this.promo_should_be_executed) {
          if (this.free_product_in_cart) {
            updateType = 'change';
          }
        }
      }
    }

    // promo type == X with Y
    else if (this.promo_type == 'x_with_y') {
      // if promo is executed
      if (this.promo_executed) {
        if (!this.promo_should_be_executed && !this.promo_is_valid) {
          updateType = 'change';
        }
      }
      // if promo is not executed
      else {
        if (this.free_product_in_cart) {
          updateType = 'change';
        }
        if (this.promo_should_be_executed && this.initiator_product_in_cart) {
          updateType = 'add';
          if (this.free_product_in_cart) {
            updateType = 'edit';
          }
        }
      }
    }

    if (this.promo_declined) {
      updateType = false;
    }

    if (updateType !== false) {
      this.updatePromotionItem(updateType);
    }

  }

  updatePromotionItem(status) {

    let cart_url = `${routes.cart_change_url}`,
        body = '',
        line = '',
        quantity = '',
        properties = {};

    // update existing product in the cart
    if (status == 'change' || status == 'edit') {

      line = document.querySelector('[data-product-promotions]').dataset.productPromotions,
      quantity = document.querySelector('[data-product-promotions-quantity]').dataset.productPromotionsQuantity;

      // set properties
      if (status == 'edit') {
        properties['_promotion'] = true;
      }

      if (document.querySelector('[data-product-promotions] [data-cart-gift-wrap]:checked')) {
        properties['_gift_wrap'] = true;
      }

      body = JSON.stringify({
        quantity: parseFloat(quantity),
        line: parseFloat(line),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      if (properties.length > 0) {
        body = JSON.stringify({
          quantity: parseFloat(quantity),
          line: parseFloat(line),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
          properties
        });
      }

    }
    // add new product to the cart
    else if (status == 'add') {

      // set properties
      properties['_promotion'] = true;

      cart_url = `${routes.cart_add_url}`;
      body = JSON.stringify({
        quantity: 1,
        id: this.free_product,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
        properties
      });
    }

    fetch(cart_url, {...fetchConfig(), ...{ body }})
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      this.getSectionsToRender().forEach((section => {

        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      // listen for promo decline
      if (document.querySelector('[data-promo-remove]')) {
        document.querySelector('[data-promo-remove]').addEventListener('click', this.declinePromo);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  declinePromo() {
    sessionStorage.setItem('promo_declined', true);
  }

  /////
  //  index Helpers
  ////

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle(parsedState.sections['cart-drawer'] ? 'cart-drawer-is-empty' : 'is-empty', parsedState.item_count === 0);

        function handleResponse() {
          JSON.parse(this.responseText);
        }

        const request = new XMLHttpRequest();
        request.addEventListener('load', handleResponse);
        request.open('GET', '/?sections=promotions', true);
        request.send();

        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));

        this.updateProgressBar(parsedState);

        this.updateLiveRegions(line, parsedState.item_count);

        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();

        if (document.querySelector('[data-product-giftwrap]') !== null) {
          let product = false;
          let giftWrapID = document.querySelector('[data-product-giftwrap]').dataset.productId;
          this.decreaseGiftWrap(product, giftWrapID);
        }
        let giftWrapId = '';
        let target = '';
        if (document.querySelector('[data-cart-gift-product]') !== null) {
          giftWrapId = document.querySelector('[data-cart-gift-product]').dataset.cartGiftProduct
        }
        if (typeof event !== 'undefined') {
          target = event.target;
        }
        this.calculateGiftWrap(giftWrapId, target);

        this.initPromotions();

        this.disableLoading();
      })
      .catch((error) => {
        document.querySelector('.loading-overlay').classList.add('hidden');
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-giftwrap-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
      {
        id: 'cart-promotions',
        section: document.getElementById('cart-promotions').dataset.id,
        selector: '.js-cart-promotions',
      },
    ];
  }

  updateProgressBar(cart) {
    this.progressBar = this.querySelector('.progress-bar');
    // Dispatch the event so the progress bar component can pick it up.
    this.progressBar.dispatchEvent(new CustomEvent('update', {
      bubbles: true,
      detail: {
        cart,
      },
    }));
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, itemCount) {

    if (this.currentItemCount === itemCount) {
      if (document.getElementById(`Line-item-error-${line}`) !== null) {
        document.getElementById(`Line-item-error-${line}`)
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    document.querySelector('.loading-overlay').classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}



if (!customElements.get('progress-bar')) {
  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.text = this.querySelector('[data-text]');
      this.fill = this.querySelector('[data-fill]');
      this.config = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.addEventListener('update', (event)=> {
        this.updateState(event);
      });
    }
    updateState(event) {
      if(!event?.detail?.cart?.total_price) {
        return;
      }
      const threshold = parseInt(this.dataset.threshold);
      const totalPrice = event.detail.cart.total_price;
      let text = this.config.strings.afterText;

      // Calculate percentage progress
      let price_difference = 0;
      let percentage = 100;
      if(threshold >= totalPrice) {
        price_difference = threshold - totalPrice;
        percentage = (totalPrice / threshold) * 100;
        const price = formatMoney(price_difference, shopMoneyFormat);
        text = (this.config.strings.beforeText).replace('[[money]]', price);
      }
      // Update state in dom
      this.fill.style.width = `${percentage}%`;
      this.text.innerHTML = text;
    }

  }
  customElements.define('progress-bar', ProgressBar);
}
